<template>
    <div class="filter-component">
        <div class="display-text" @click.stop="toggle" ref="display">
            {{ displayText }}
            <i class="material-icons">{{ iconName }}</i>
        </div>
        <div class="filter-content" v-if="open" v-click-outside="close">
            <slot />
        </div>
    </div>
</template>
<script setup>
import { computed, ref } from 'vue'

const props = defineProps({
    displayText: {
        type: String,
        required: true,
    },
})

const display = ref(null)
const open = ref(false)

function toggle() {
    open.value = !open.value
}

function close(event) {
    if (!event?.target || !display.value?.contains(event.target)) {
        open.value = false
    }
}

const iconName = computed(() => (open.value ? 'arrow_drop_up' : 'arrow_drop_down'))

defineExpose({ close })
</script>
<style>
.filter-component {
    display: inline-block;
    color: var(--color-primary-600);
    position: relative;
    margin-right: 24px;

    div.display-text {
        cursor: pointer;
        display: block;
        line-height: 32px;
        text-transform: uppercase;
        font-weight: var(--weight-bold);
        font-size: var(--font-size-caption);
        color: var(--color-primary-600);

        i.material-icons {
            position: relative;
            top: 6px;
        }
    }

    .filter-content {
        min-width: 324px;
        max-height: 50vh;
        overflow: auto;
        overflow-x: hidden;
        position: absolute;
        top: 40px;
        left: 0;
        padding: 24px 16px;
        display: inline-block;
        box-shadow: var(--boxshadow-default);
        z-index: var(--z-index-dropdown-menu);
        background-color: var(--color-light);
    }
}
</style>
